<template>
  <div>
    <el-row class="q-title">
      <span>{{ title }}</span>
    </el-row>
    <el-row class="q-subtitle">
      <slot></slot>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, default: "" }
  }
};
</script>

<style scoped>
.q-title {
  font-size: 20px;
}
.q-subtitle {
  color: #666;
  line-height: 1.5;
  font-size: 14px;
}
</style>
